import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {User} from '../../../../models/user';
import {UserService} from '../../../../services/user/user.service';
import {LoaderService} from '../../../../services/loader/loader.service';
import {Paginator} from '../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../tools/table-sorter/table-sorter';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {TableSorterDirective} from '../../../../directives/table-sorter/table-sorter.directive';
import {TableSorterHeaderDirective} from '../../../../directives/table-sorter/table-sorter-header.directive';
import {RouterLink} from '@angular/router';
import {ConfirmDirective} from '../../../../directives/confirm/confirm.directive';
import {IsGrantedDirective} from '../../../../directives/is-granted/is-granted.directive';
import {ImageService} from '../../../../services/image/image.service';
import {MetaTitle} from '../../../../decorator/meta-title';
import {IsGranted} from '../../../../decorator/is-granted';

@Component({
  selector: 'app-user-list',
  imports: [
    DatePipe,
    PaginatorComponent,
    TableSorterDirective,
    TableSorterDirective,
    TableSorterHeaderDirective,
    RouterLink,
    ConfirmDirective,
    NgOptimizedImage,
    IsGrantedDirective
],
  templateUrl: './user-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-list.component.scss'
})
@IsGranted(['USER_VIEW'])
@MetaTitle('Users')
export class UserListComponent implements OnInit {

  users: User[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('lastname', 'asc');

  constructor(
    protected imageService: ImageService,
    private userService: UserService,
    private loader: LoaderService,
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.userService.findAll({groups: 'image'}, this.paginator, this.tableSorter).subscribe((users) => {
      this.users = users;

      this.loader.stopLoading();
    });
  }

  delete(user: User): void {
    if (user.id) {
      this.loader.startLoading();
      this.userService.delete(user.id).subscribe(() => {
        this.fetchAll();
      });
    }
  }

  getRole(user: User): string {
    if (user.roles.includes('ROLE_API_DEV')) {
      return 'Dev';
    }

    if (user.roles.includes('ROLE_API_SUPER_ADMIN')) {
      return 'Super Admin';
    }

    if (user.roles.includes('ROLE_API_ADMIN')) {
      return 'Admin';
    }

    return 'User';
  }
}
